import Rest from '../Rest'

export default class DocumentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/documents'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  deleteAttachment(id: Number, mediaId: Number) {
    return this.delete(`${id}/files/${mediaId}`)
  }

  getCategories() {
    return this.get('/categories')
  }

  getCategoriesGrid() {
    return this.get('/categories/grid')
  }

  getItemsByCategory(categoryId) {
    return this.get(`/categories/${categoryId}/items`)
  }
  // Destination
  addEmailDestination(documentId, destinations) {
    return this.post(`/${documentId}/destinations`, {
      destinations: destinations
    })
  }

  deleteDestination(documentId, destinationId) {
    return this.delete(`/${documentId}/destinations/${destinationId}`)
  }

  dispatch(documentId) {
    return this.post(`/${documentId}/dispatch`)
  }

  dispatchDestination(documentId, destinationId) {
    const destinations = [destinationId]
    return this.post(`/${documentId}/destinations/${destinationId}/dispatch`, {
      destinations: destinations
    })
  }

  downloadAll(documentId, documentName) {
    return this.download(`/${documentId}/files`, documentName, 'application/x-zip')
  }

  getFilesDownloadLink(documentId: Number){
    return this.get(`/${documentId}/download/link`)
  }
}
